var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "declaration-scope" }, [
    _c("div", { staticStyle: { display: "flex" } }, [
      _c(
        "div",
        {
          staticClass: "show-right section",
          staticStyle: { width: "60%", "background-color": "#FFFFFF" }
        },
        [
          _c(
            "div",
            {
              staticClass: "main-content left",
              staticStyle: { "margin-left": "20px", "margin-bottom": "50px" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    disabled: _vm.useHqSet,
                    "label-width": "130px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "el-form-item-wrapper",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_UnregisteredShippingRate"
                                )
                              )
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.declaredWarnType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "declaredWarnType", $$v)
                                },
                                expression: "form.declaredWarnType"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { label: 1, disabled: !_vm.isEdit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_ProhibitSaving")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { label: 2, disabled: !_vm.isEdit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_NotifyUser"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { label: 3, disabled: !_vm.isEdit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_RecordOnly"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { label: 4, disabled: !_vm.isEdit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_NoRecordNoAlert")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "declaredWarnRole",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.declaredWarnRole,
                                  "declaredWarnRoleArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.declaredWarnRole,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "declaredWarnRole", $$v)
                              },
                              expression: "form.declaredWarnRole"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_NotifyRoleByEmail"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              disabled: !(
                                _vm.isEdit && _vm.form.declaredWarnRole
                              ),
                              placeholder: " ",
                              filterable: "",
                              "static-options": _vm.roles,
                              "default-multiple-value":
                                _vm.form.declaredWarnRoleArray,
                              multiple: true,
                              cache: false,
                              "tag-name": "code",
                              "tag-value": "value",
                              "filter-tag-names": ["code"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.declaredWarnRoleArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "declaredWarnUser",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.declaredWarnUser,
                                  "declaredWarnUserArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.declaredWarnUser,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "declaredWarnUser", $$v)
                              },
                              expression: "form.declaredWarnUser"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_NotifyPersonByEmail")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "declaredWarnUserArray",
                              disabled: !(
                                _vm.isEdit && _vm.form.declaredWarnUser
                              ),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              filterable: "",
                              clearable: false,
                              "default-multiple-value":
                                _vm.form.declaredWarnUserArray,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.declaredWarnUserArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "declaredWarnPosition",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.declaredWarnPosition,
                                  "declaredWarnPositionArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.declaredWarnPosition,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "declaredWarnPosition", $$v)
                              },
                              expression: "form.declaredWarnPosition"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_NotifyPositionByEmail")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "declaredWarnPositionArray",
                              disabled: !(
                                _vm.isEdit && _vm.form.declaredWarnPosition
                              ),
                              placeholder: " ",
                              "static-options": _vm.positions,
                              filterable: "",
                              "default-multiple-value":
                                _vm.form.declaredWarnPositionArray,
                              multiple: true,
                              "tag-name": "chineseName",
                              "tag-value": "code",
                              "custom-label": function(item) {
                                return "" + item.chineseName
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.declaredWarnPositionArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-form-item-wrapper",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ExceedMaintainedLimit")
                              )
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.transfiniteWarnType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "transfiniteWarnType", $$v)
                                },
                                expression: "form.transfiniteWarnType"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { label: 1, disabled: !_vm.isEdit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_ProhibitSaving")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { label: 2, disabled: !_vm.isEdit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_NotifyUser"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { label: 3, disabled: !_vm.isEdit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_RecordOnly"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { label: 4, disabled: !_vm.isEdit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_NoRecordNoAlert")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "transfiniteWarnRole",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.transfiniteWarnRole,
                                  "transfiniteWarnRoleArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.transfiniteWarnRole,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transfiniteWarnRole", $$v)
                              },
                              expression: "form.transfiniteWarnRole"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_NotifyRoleByEmail"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              disabled: !(
                                _vm.isEdit && _vm.form.transfiniteWarnRole
                              ),
                              placeholder: " ",
                              filterable: "",
                              "static-options": _vm.roles,
                              "default-multiple-value":
                                _vm.form.transfiniteWarnRoleArray,
                              multiple: true,
                              cache: false,
                              "tag-name": "code",
                              "tag-value": "value",
                              "filter-tag-names": ["code"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.transfiniteWarnRoleArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "transfiniteWarnUser",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.transfiniteWarnUser,
                                  "transfiniteWarnUserArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.transfiniteWarnUser,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transfiniteWarnUser", $$v)
                              },
                              expression: "form.transfiniteWarnUser"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_NotifyPersonByEmail")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "transfiniteWarnUserArray",
                              disabled: !(
                                _vm.isEdit && _vm.form.transfiniteWarnUser
                              ),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              filterable: "",
                              clearable: false,
                              "default-multiple-value":
                                _vm.form.transfiniteWarnUserArray,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.transfiniteWarnUserArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "transfiniteWarnPosition",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.transfiniteWarnPosition,
                                  "transfiniteWarnPositionArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.transfiniteWarnPosition,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "transfiniteWarnPosition",
                                  $$v
                                )
                              },
                              expression: "form.transfiniteWarnPosition"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_NotifyPositionByEmail")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "transfiniteWarnPositionArray",
                              disabled: !(
                                _vm.isEdit && _vm.form.transfiniteWarnPosition
                              ),
                              placeholder: " ",
                              "static-options": _vm.positions,
                              filterable: "",
                              "default-multiple-value":
                                _vm.form.transfiniteWarnPositionArray,
                              multiple: true,
                              "tag-name": "chineseName",
                              "tag-value": "code",
                              "custom-label": function(item) {
                                return "" + item.chineseName
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.transfiniteWarnPositionArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-form-item-wrapper",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RPAPaused")))]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "rpaPauseWarnRole",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.rpaPauseWarnRole,
                                  "rpaPauseWarnRoleArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.rpaPauseWarnRole,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "rpaPauseWarnRole", $$v)
                              },
                              expression: "form.rpaPauseWarnRole"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_NotifyRoleByEmail"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              disabled: !(
                                _vm.isEdit && _vm.form.rpaPauseWarnRole
                              ),
                              placeholder: " ",
                              filterable: "",
                              "static-options": _vm.roles,
                              "default-multiple-value":
                                _vm.form.rpaPauseWarnRoleArray,
                              multiple: true,
                              cache: false,
                              "tag-name": "code",
                              "tag-value": "value",
                              "filter-tag-names": ["code"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.rpaPauseWarnRoleArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "rpaPauseWarnUser",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.rpaPauseWarnUser,
                                  "rpaPauseWarnUserArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.rpaPauseWarnUser,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "rpaPauseWarnUser", $$v)
                              },
                              expression: "form.rpaPauseWarnUser"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_NotifyPersonByEmail")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "rpaPauseWarnUserArray",
                              disabled: !(
                                _vm.isEdit && _vm.form.rpaPauseWarnUser
                              ),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              filterable: "",
                              clearable: false,
                              "default-multiple-value":
                                _vm.form.rpaPauseWarnUserArray,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.rpaPauseWarnUserArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "el-form-item-wrapper",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_RPACompleted"))
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "rpaCompletedWarnRole",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.rpaCompletedWarnRole,
                                  "rpaCompletedWarnRoleArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.rpaCompletedWarnRole,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "rpaCompletedWarnRole", $$v)
                              },
                              expression: "form.rpaCompletedWarnRole"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_NotifyRoleByEmail"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              disabled: !(
                                _vm.isEdit && _vm.form.rpaCompletedWarnRole
                              ),
                              placeholder: " ",
                              filterable: "",
                              "static-options": _vm.roles,
                              "default-multiple-value":
                                _vm.form.rpaCompletedWarnRoleArray,
                              multiple: true,
                              cache: false,
                              "tag-name": "code",
                              "tag-value": "value",
                              "filter-tag-names": ["code"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.rpaCompletedWarnRoleArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              no: "rpaCompletedWarnUser",
                              disabled: !_vm.isEdit
                            },
                            on: {
                              change: function($event) {
                                return _vm.uncheckClearValue(
                                  _vm.form.rpaCompletedWarnUser,
                                  "rpaCompletedWarnUserArray"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.rpaCompletedWarnUser,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "rpaCompletedWarnUser", $$v)
                              },
                              expression: "form.rpaCompletedWarnUser"
                            }
                          }),
                          _c("span", { staticClass: "label-span" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_NotifyPersonByEmail")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              no: "rpaCompletedWarnUserArray",
                              disabled: !(
                                _vm.isEdit && _vm.form.rpaCompletedWarnUser
                              ),
                              placeholder: " ",
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              filterable: "",
                              clearable: false,
                              "default-multiple-value":
                                _vm.form.rpaCompletedWarnUserArray,
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.rpaCompletedWarnUserArray = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }